var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deleteForm"},[_c('p',{staticClass:"control",on:{"click":function($event){return _vm.deleteSchedule()}}},[_c('a',{staticClass:"button is-danger"},[_vm._v("\n    削除\n  ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66cd1564","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/DeleteSchedule.vue
// module id = null
// module chunks = 